import { render } from "./ParentWallet.vue?vue&type=template&id=406fac1c&scoped=true"
import script from "./ParentWallet.vue?vue&type=script&lang=js"
export * from "./ParentWallet.vue?vue&type=script&lang=js"

import "./ParentWallet.vue?vue&type=style&index=0&id=406fac1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406fac1c"]])

export default __exports__